/**
 * AI로 보내기 전 핵심 개인정보만 가린다.
 * 가리는 것: 주민등록번호, 카드번호, 전화번호, 이메일, 계좌번호, 상세주소(동·호, 도로명 번지)
 * 가리지 않는 것: 학생·교사 이름, 학교명 (수업 맥락이라 필요)
 */

const RULES = [
  { re: /\b\d{6}\s?-\s?[1-4]\d{6}\b/g, mask: '[주민번호]' },
  { re: /\b\d{4}[- ]\d{4}[- ]\d{4}[- ]\d{4}\b/g, mask: '[카드번호]' },
  { re: /\b01[016789][- .]?\d{3,4}[- .]?\d{4}\b/g, mask: '[전화번호]' },
  { re: /\b0(?:2|[3-6][1-5]|70)[- .]\d{3,4}[- .]\d{4}\b/g, mask: '[전화번호]' },
  { re: /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/g, mask: '[이메일]' },
  {
    // 날짜(2026-09-28)와 헷갈리지 않게 숫자 10자리 이상·세 묶음 이상만 계좌로 본다.
    re: /\b\d{2,6}-\d{2,6}-\d{2,8}(?:-\d{1,4})?\b/g,
    mask: '[계좌번호]',
    when: (m) => m.replace(/\D/g, '').length >= 10,
  },
  { re: /\d{1,4}\s?동\s?\d{1,5}\s?호/g, mask: '[상세주소]' },
  {
    // "앞으로 10분", "새로 3개" 같은 말은 건드리지 않게 시·군·구 뒤의 도로명 + 번지만 본다.
    re: /([가-힣]+(?:시|군|구|읍|면)\s+[가-힣0-9]+(?:대로|로|길))\s?\d{1,5}(?:-\d{1,5})?(?:번길\s?\d{1,5})?(?![\d-]|\s?(?:분|개|장|문|명|번|쪽|초|시간|가지|%))/g,
    mask: '$1 [번지]',
  },
];

const applyRule = (text, rule) => {
  let hits = 0;
  const next = text.replace(rule.re, (match, ...groups) => {
    if (rule.when && !rule.when(match)) return match;
    hits += 1;
    return rule.mask.replace('$1', typeof groups[0] === 'string' ? groups[0] : '');
  });
  return { next, hits };
};

export function maskCriticalPII(input) {
  return RULES.reduce((acc, rule) => {
    const { next, hits } = applyRule(acc.text, rule);
    return { text: next, count: acc.count + hits };
  }, { text: String(input ?? ''), count: 0 });
}

export default maskCriticalPII;
